import { Fade, Stack } from '@mui/material';
import { memo } from 'react';

import { VpButton } from '@vp/common/ui/component/VpButton';

export type AccessManagerControlsProps = {
  shown: boolean;
  applying: boolean;
  onCancel: () => void;
  onApply: () => void;
};

export const AccessManagerControls = memo<AccessManagerControlsProps>(({ shown, applying, onCancel, onApply }) => {
  return (
    <Fade in={shown} timeout={250} easing="ease-in-out">
      <Stack
        position="sticky"
        bottom={0}
        width={1}
        pt={1}
        marginTop="auto"
        pb={{ mobile: 2, tablet: 4 }}
        px={{ mobile: 3, tablet: 7 }}
        gap={1}
        direction="row"
        sx={{ backgroundColor: 'background.300' }}
      >
        <VpButton disabled={applying} text="Отменить" status="primary" variant="soft" size="small" sx={{ flex: 1 }} onClick={onCancel} />
        <VpButton loading={applying} text="Применить" status="primary" variant="solid" size="small" sx={{ flex: 1 }} onClick={onApply} />
      </Stack>
    </Fade>
  );
});

AccessManagerControls.displayName = 'AccessManagerControls';
